import PropTypes from 'prop-types';
import qs from 'qs';
import { Component } from 'react';

const utmRegex = /utm_medium|utm_campaign|utm_source/gi;

class LocalCampaign extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  constructor(props) {
    super(props);
    this.setCampaign(props);
  }

  setCampaign({ eventId }) {
    if (typeof document !== 'undefined') {
      const { URL: url } = document;
      const referrer = qs.parse(window.location.search, { ignoreQueryPrefix: true }).referrer;

      if (referrer || (url && url.match(utmRegex))) {
        try {
          localStorage.setItem(`campaign_${eventId}`, JSON.stringify({ url, referrer }));
        } catch (e) {}
      }
    }
  }

  render() {
    return this.props.children;
  }
}

export default LocalCampaign;



// WEBPACK FOOTER //
// ./src/campaign/LocalCampaign.js